import { ComponentType, ReactNode } from "react";

import { HistoryCardTextInfoItem } from "shared/ui/activity-log/cards-v2/base";
import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface HistoryCardActivityTypeConfigI {
  icon: ComponentType<PropsWithClassNameI>;
  iconClassName?: string;
  infoClassName?: string;
  title: ReactNode;
  isHot?: boolean;
  isWarning?: boolean;
  isSuccess?: boolean;
}

interface HistoryCardActivityTypePropsI extends PropsWithClassNameI {
  config: HistoryCardActivityTypeConfigI;
}

export const HistoryCardActivityType = ({
  config: { icon: Icon, title, isHot, isWarning, isSuccess, infoClassName },
  className,
}: HistoryCardActivityTypePropsI) => (
  <HistoryCardTextInfoItem
    icon={
      <div className="relative">
        {isHot && (
          <span className="absolute left-1/2 -mt-4 -translate-x-1/2">🔥</span>
        )}

        <Icon className={clsxMerge("h-6 w-6", isHot && "text-error-content")} />
      </div>
    }
    subtitle="Type"
    infoClassName={clsxMerge(
      "max-w-[220px]",
      (isHot || isWarning) && "text-error-content",
      isSuccess && "text-success-content",
      infoClassName,
      className
    )}
    info={[{ title, isBold: true }]}
  />
);
